enum TextLinkIconPosition {
  LEFT = 'left',
  RIGHT = 'right',
  BOTH = 'both',
}
enum TextLinkStyle {
  CHEVRON = 'Chevron',
  CHEVRONUNDERLINE = 'Chevron&Underline',
  ICON = 'Icon',
  ICONUNDERLINE = 'Icon&Underline',
  UNDERLINE = 'Underline',
}
enum TextLinkUnderlineStyle {
  HOVER = 'UnderlineOnHover',
  NOHOVER = 'NoUnderlineOnHover',
  FIXED = 'UnderlineFixed',
}
enum TextLinkSize {
  SM = 'small',
  DEFAULT = 'default',
}
export { TextLinkIconPosition, TextLinkStyle, TextLinkUnderlineStyle, TextLinkSize };
